import { render, staticRenderFns } from "./render-display-node.vue?vue&type=template&id=13c4e22d&scoped=true&"
import script from "./render-display-node.vue?vue&type=script&lang=ts&"
export * from "./render-display-node.vue?vue&type=script&lang=ts&"
import style0 from "./render-display-node.vue?vue&type=style&index=0&id=13c4e22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4e22d",
  null
  
)

export default component.exports